// extracted by mini-css-extract-plugin
export default {"dialogHeader":"ShoppingBagModal_dialogHeader__35fv6","dialogCloseButton":"ShoppingBagModal_dialogCloseButton__PFJ3L","shoppingBag":"ShoppingBagModal_shoppingBag__2NuXN"};